const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Events Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('EventParticipation', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/learn/v3/events/:eventId/:type/:userId', null, {
    join: {params: {eventId: '', type: 'join', userId: ''}, method: 'POST', isArray: false},
    waitlist: {params: {eventId: '', type: 'adminwait', userId: ''}, method: 'POST', isArray: false},
    cancel: {params: {eventId: '', type: 'cancel', userId: ''}, method: 'POST', isArray: false},
  });
}]);
